import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'Descarga el Kit',
  description: 'Obtén acceso inmediato a todos los documentos y herramientas.'
}, {
  number: '2',
  title: 'Aplica el Triaje',
  description: 'Sigue la guía de las primeras 48 horas para asegurar tu dinero.'
}, {
  number: '3',
  title: 'Ejecuta el Salto',
  description: 'Usa el CV y el sistema de contactos para conseguir entrevistas en tiempo récord.'
}];
export function HowItWorks() {
  return <section className="bg-navy text-white py-16 px-6" data-id="element-105">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-106">
        <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center" data-id="element-107">
          Cómo <span className="text-gold" data-id="element-108">Funciona</span>
        </h2>

        <div className="space-y-8" data-id="element-109">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex items-start gap-6" data-id="element-110">
              <div className="flex-shrink-0 w-16 h-16 bg-gold rounded-full flex items-center justify-center" data-id="element-111">
                <span className="text-navy font-bold text-2xl" data-id="element-112">
                  {step.number}
                </span>
              </div>
              <div data-id="element-113">
                <h3 className="font-serif text-2xl mb-2 text-gold" data-id="element-114">
                  {step.title}
                </h3>
                <p className="text-lg text-gray-300" data-id="element-115">{step.description}</p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}